import "./../../bindings/bao-searcher";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import "./../../services/bao-router";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
import baoRouter from "./../../services/bao-router";
import * as moment from "moment";
class DailyShiftPlanCopyDialog {
    Bao = Bao;
    FromDate: KnockoutObservable<string> = ko.observable();
    ToDate: KnockoutObservable<string> = ko.observable();
    OverwriteTarget: KnockoutObservable<boolean> = ko.observable(false);
    ShiftGroupName: KnockoutObservable<string>;
    ShiftGroupId: KnockoutObservable<string>;
    DateTimeBoxFromDate: Bindings.baoDateTimeBox = {
        value: this.FromDate,
        mode: 'date',
        culture: Bao.Session.Language.Symbol()
    };
    DateTimeBoxToDate: Bindings.baoDateTimeBox = {
        value: this.ToDate,
        mode: 'date',
        culture: Bao.Session.Language.Symbol()
    };
    DatePickerFromDate: Bindings.baoDateTimePicker = {
        mode: 'date'
    };
    DatePickerToDate: Bindings.baoDateTimePicker = {
        mode: 'date'
    };
    constructor(ShiftGroupId: string, ShiftGroupName: string) {
        // set fromDate to tomorrow
        this.FromDate(moment().add(1, 'day').format(Bao.Utils.DateTimeFormat));
        // set toDate to tomorrow + 4 weeks
        this.ToDate(moment().add(1, 'day').add(4, 'week').format(Bao.Utils.DateTimeFormat));
        this.ShiftGroupName = ko.observable(ShiftGroupName);
        this.ShiftGroupId = ko.observable(ShiftGroupId);
    }
}
export default DailyShiftPlanCopyDialog;